export default __webpack_public_path__ + "static/media/product-car--green.4eb244ae.svg";